import type { schemaType as StrapiEscapadasDetailSchemaType } from '~~/modules/api/strapi/escapadas/detail/schema'
import type { schemaType as StrapiCottagesPagechemaType } from '~~/modules/api/strapi/cottages-page/schema'
import type { propsInterface } from '~~/modules/design-system/sections/s-links/s-links-wrapper.vue'

export const useToSLinksWrapper = () => {
  const fromStrapiEscapadasDetail = (params: {
    dataIn: StrapiEscapadasDetailSchemaType
  }) => {
    let items: propsInterface['items'] = []

    if (params.dataIn.attributes.seo_links) {
      items = params.dataIn.attributes.seo_links.map(seoLink => ({
        title: seoLink.title || undefined,
        links: {
          items: seoLink.link.map(link => ({
            name: link.text,
            href: link.url,
          })),
        },
      }))
    }

    return { items }
  }

  const fromStrapiCottagesPage = (params: {
    dataIn: StrapiCottagesPagechemaType
  }) => {
    let items: propsInterface['items'] = []

    if (params.dataIn.attributes.seo_links) {
      items = params.dataIn.attributes.seo_links.map(seoLink => ({
        title: seoLink.title || undefined,
        links: {
          items: seoLink.link.map(link => ({
            name: link.text,
            href: link.url,
          })),
        },
      }))
    }

    return { items }
  }

  return {
    fromStrapiEscapadasDetail,
    fromStrapiCottagesPage,
  }
}
